<template>
  <div
    class="field-control eds-input"
    :class="[`input-${state}`, fieldControlClass]"
    :style="fieldControlStyle"
  >
    <div
      v-if="$slots.prepend"
      class="input-prepend eds-input-addon input-gray"
      :class="prependClass"
      :style="prependStyle"
    >
      <span
        class="input-addon-content"
        :class="[
          {
            'input-addon-text': prependType === 'text',
            'input-icon': prependType === 'icon',
          },
          prependTextClass,
        ]"
        :style="prependTextStyle"
      >
        <slot name="prepend" />
      </span>
    </div>
    <textarea
      v-bind="$attrs"
      v-focus="autoFocus"
      :value="modelValue"
      class="input-element"
      :class="inputClass"
      :style="inputStyle"
      @input="$emit('update:modelValue', ($event.target as any)?.value)"
    />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'Textarea',
    inheritAttrs: false,
    emits: ['update:modelValue'],
    directives: {
      focus: {
        // provides autofocus of input field
        mounted(el, binding) {
          if (binding.value) el.focus();
        },
      },
    },
    props: {
      modelValue: {
        type: [String, Number],
        required: false,
        default: '',
      },
      state: {
        type: String,
        required: false,
        default: 'basic',
        validator: (value: string) => {
          return ['basic', 'warning', 'error'].includes(value);
        },
      },
      autoFocus: {
        type: Boolean,
        required: false,
        default: false,
      },
      inputClass: {
        type: String,
        required: false,
        default: '',
      },
      inputStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      fieldControlClass: {
        type: String,
        required: false,
        default: '',
      },
      fieldControlStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      prependClass: {
        type: String,
        required: false,
        default: '',
      },
      prependStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      prependType: {
        type: String,
        required: false,
        default: 'text',
        validator: (value: string) => {
          return ['text', 'icon'].includes(value);
        },
      },
      prependTextClass: {
        type: String,
        required: false,
        default: '',
      },
      prependTextStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
    },
  });
</script>
